function* flatten(arrays) {
  for (const array of arrays) {
    yield* array;
  }
}

export default function merge(arrays) {
  return Array.from(flatten(arrays));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo/node_modules/d3-array/src/merge.js
// module id = null
// module chunks = 